var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { Alert, LinearProgress } from '@mui/material';
import * as Preact from 'preact';
import * as SharingIcons from './M_SharingIcons';
import * as ActionBarModal from './O_ActionBarModal';
export var Component = function (p) {
    return (Preact.h(ActionBarModal.Component, { open: p.open, onCloseClick: p.onCloseClick, title: p.title, sx: p.sx },
        Preact.h(Preact.Fragment, null,
            p.url ? Preact.h(SharingIcons.Component, __assign({}, p, { url: p.url })) : Preact.h(LinearProgress, null),
            p.showLinkAlert && (Preact.h(Alert, { severity: "success", sx: { margin: '0 24px 24px' } }, p.linkAlertText)))));
};
Component.displayName = 'SharingModal';
